'use strict';

angular.module('mean.general-tasks').controller('TradeCodeController', ['$scope', 'tradeCodeService', 'Global', 'TradeCodes',
  function ($scope, tradeCodeService, Global, TradeCodes) {

    $scope.global = Global;
    $scope.tradeCodes = [];
    $scope.tradeLists = [];
    $scope.formValue = { code: '', name: '' };
    $scope.isValidEntry = false;

    $scope.init = () => {
      for (var i = 0; i < 100; i++) {
        (i < 10) ? $scope.tradeCodes.push('0' + i) : $scope.tradeCodes.push(i.toString());
      }

      TradeCodes.query({}, (results) => {
        $scope.tradeLists = results;
      });
    }

    $scope.submitForm = () => {
      var found = $scope.tradeLists.filter(item => item.code === $scope.formValue.code);
      if (!found.length && $scope.isValidEntry) {
        var newTradeCode = new TradeCodes({
          code: $scope.formValue.code,
          name: $scope.formValue.name
        });
        newTradeCode.$save((result) => {
          (result) && $scope.tradeLists.push(result) && ($scope.formValue = {});
          tradeCodeService.updateTrades();
        })
      }
    }

    $scope.checkDuplicates = (field, value) => {
      if (!value) return false;
      var isExist = $scope.tradeLists.filter(item => item[field].toLowerCase() === value.toLowerCase());
      $scope.isValidEntry = !isExist.length;
      return !isExist.length
    }

  }
]);



// WEBPACK FOOTER //
// ./packages/custom/general-tasks/public/controllers/tradeCodes.js